import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mdc-data-table',
  templateUrl: './mdc-data-table.component.html',
  styleUrls: ['./mdc-data-table.component.scss']
})
export class MdcDataTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
